import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { from, of } from 'rxjs';
import { catchError, concatMap, first, map, switchMap } from 'rxjs/operators';

import { AZURE_CA_URLS } from 'src/app/shared/enums/HttpStatusCodes';
import { IRequestEndpoint } from 'src/app/shared/models/request.model';
import { ICallableAssistance, ICaseAssistance } from '../../shared/models/Assistance';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    errorGetOptionsAssistance,
    errorSaveAssistance,
    getOptionsAssistance,
    saveAssistance,
    successGetOptionsAssistance,
    successSaveAssistance,
} from '../actions/assistance.actions';
import { IIntervalSave } from './../../shared/enums/UpdateInfo';
import { GESTION_TICKETS_ENDPOINTS, NativeStorageNamesV2 } from './../../shared/models/Constants';
import { StorageData } from './../../shared/services/utilities/storage-data.class';

@Injectable()
export class AsisstanceEffets {
    private keyStorage = NativeStorageNamesV2.ObtieneOpcionesAsistencia;

    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
        , private translate: TranslateService
    ) { }

    public getOptionsAssistance$ = createEffect(
        () => this.actions$.pipe(
            ofType(getOptionsAssistance),
            switchMap(
                (actions: { api: IRequestEndpoint }) => from(StorageData.getDataStorage(this.keyStorage))
                    .pipe(
                        concatMap((storage: ISaveOptions) => this.translate.get('Miscellaneous.updateinterval5').pipe(first(), map((UpdateInterval5: IIntervalSave) => ({ storage, UpdateInterval5 })))),
                        concatMap(({ storage, UpdateInterval5 }) => this.httpS.getStorage(storage, this.keyStorage, UpdateInterval5, 'executeRequestByUser', actions.api, null, this.httpS.getAzureCAUrl(AZURE_CA_URLS.GESTION_TICKETS)))
                    )
            ),
            map(resp => successGetOptionsAssistance(resp)),
            catchError((err: Error) => of(errorGetOptionsAssistance({ payload: err })))
        )
    );

    public saveAssistance$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveAssistance),
            switchMap((actions: ICallableAssistance) =>
                this.httpS.executeRequestByUser(GESTION_TICKETS_ENDPOINTS.post_save_assistance, actions.params, this.httpS.getAzureCAUrl(AZURE_CA_URLS.GESTION_TICKETS))
                    .pipe(
                        map(resp => successSaveAssistance(resp)),
                        catchError((err: Error) => of(errorSaveAssistance({ payload: err })))
                    )
            )
        )
    );

}

interface ISaveOptions {
    fecha: string;
    data: ICaseAssistance[];
}
